export default __webpack_public_path__ + "static/helix-ps-5-68f7c8991a2ae76d6b415a820135cb9c.jpg";